export const getSiteCurrency = () => {
    return localStorage.getItem("currency") || sessionStorage.getItem("currency") || "$";
};

export const formatMoney = (amount, currency = getSiteCurrency()) => {
    if (typeof amount === "string" && amount.trim().toLowerCase() === "free") {
        return amount;
    }

    const value = amount === null || amount === undefined || amount === ""
        ? 0
        : String(amount)
            .replace(/FCFA|F CFA|CFA|XOF|XAF|GNF|CDF|USD|EUR|GBP|NGN|₹|\$|€/gi, "")
            .replace(/\s+/g, " ")
            .trim();

    return `${value} ${currency}`;
};

export const formatSignedMoney = (amount, sign = "", currency = getSiteCurrency()) => {
    return `${sign}${formatMoney(amount, currency)}`;
};
